import React from "react";
import { Modal } from "antd";

class Popup extends React.Component {
  // list of states
  constructor(props) {
    super(props);
    this.state = {
      status: false,
    };
  }
  render() {
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onOk={this.props.onOk}
        onCancel={this.props.onCancel}
        okText={this.props.okText}
        cancelText={this.props.cancelText}
        style={this.props.style ? this.props.style : {}}
        width={this.props.width ? this.props.width : {}}
      >
        {this.props.children}
      </Modal>
    );
  }
}
export default Popup;